import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export const MenuItem: React.FC<{
  icon: React.ReactNode
  text: string
  isActive?: boolean
  asChild?: boolean
  rightComponent?: React.ReactNode
  onClick?: () => void
}> = ({ icon, text, isActive, asChild = true, rightComponent, onClick }) => {
  return (
    <Button
      className={cn(
        'flex w-full items-center justify-start rounded px-4 py-2 text-sm font-medium',
        !!isActive && 'bg-secondary'
      )}
      variant="ghost"
      size="sm"
      asChild={asChild}
      onClick={onClick}
    >
      <span className={cn('flex items-center', 'w-full')}>
        {icon}
        <span className={cn('pl-2')}>{text}</span>
        {rightComponent}
      </span>
    </Button>
  )
}
